import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { readonly nombre: string; readonly children: ReactNode };
type State = { readonly error: Error | null };

/**
 * Un fallo de render en un panel no debe dejar la página en negro: se muestra
 * el error acotado al panel y el resto sigue funcionando.
 */
export class BarreraErrores extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(`Fallo en ${this.props.nombre}`, error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error !== null) {
      return (
        <section role="alert" style={{ margin: '1rem 0' }}>
          <strong>{this.props.nombre}</strong> no se ha podido mostrar: {this.state.error.message}.
          <br />
          <small>Recarga la página; si persiste, puede que el servidor esté sirviendo una versión anterior de la API.</small>{' '}
          <button type="button" onClick={() => this.setState({ error: null })}>Reintentar</button>
        </section>
      );
    }
    return this.props.children;
  }
}
